<template>
  <div class="weekly-view-wbs w-full max-w-full min-w-0 bg-white border rounded-lg overflow-hidden" style="border-color: #5b80be;">
    <!-- Barra resumen -->
    <div
      class="flex flex-wrap items-center justify-between gap-2 py-1 px-3 text-sm border-b"
      style="background-color: #eef3fb; border-color: #c5d4eb;"
    >
      <div class="flex items-center gap-1.5 font-semibold" style="color: #3b66bc;">
        <b-icon pack="fas" icon="list" size="is-small" />
        <span
          class="inline-flex items-center py-px px-1 rounded-sm text-white font-bold uppercase"
          style="background-color: #3b66bc; font-size: 10px;"
        >WBS</span>
        <span>{{ summaryCounts }}</span>
      </div>
      <div class="font-medium text-grey-darker">
        {{ weekSummaryLabel }}
      </div>
    </div>

    <!-- Grupos / filtros -->
    <div class="flex flex-wrap items-center gap-1.5 py-2 px-4 border-b" style="border-color: #c5d4eb;">
      <span class="inline-flex items-center gap-1 mr-1 text-xs font-bold uppercase text-gray-500">
        <b-icon pack="fas" icon="eye" size="is-small" />
        {{ $t('groups') }}
      </span>
      <button
        v-for="group in groupFilters"
        :key="group.key"
        type="button"
        class="activities-weekly-table__group-chip inline-flex items-center gap-1.5 py-0.5 px-2 border-0 rounded-full text-white text-xs font-bold cursor-pointer"
        :class="{ 'activities-weekly-table__group-chip--hidden': isGroupHidden(group.columnGroup) }"
        :style="{ backgroundColor: group.color }"
        :aria-pressed="isGroupHidden(group.columnGroup)"
        @click="toggleColumnGroup(group.columnGroup)"
      >
        {{ $t(group.labelKey) }}
        <span class="inline-flex items-center justify-center min-w-4 h-4 px-1 rounded-full bg-white text-gray-800 text-xs font-bold">{{ group.count }}</span>
      </button>
    </div>

    <weekly-wbs-groups
      :project-id="projectId"
      :week-start-date="weekStartDate"
      :week-end-date="weekEndDate"
      :week-number="weekNumber"
      :hidden-column-groups="hiddenColumnGroups"
      :filter-subactivities-by-week="filterSubactivitiesByWeek"
      :reschedule-mode="rescheduleMode"
      :edited-subactivities="editedSubactivities"
      :activity-filters="activityFilters"
      :selected-discipline-id="selectedDisciplineId"
      @update-rescheduled-activity="$emit('update-rescheduled-activity', $event)"
      @remove-rescheduled-activity="$emit('remove-rescheduled-activity', $event)"
    />

    <!--
    <activities-weekly-table
      :project-id="projectId"
      :week-start-date="weekStartDate"
      :week-end-date="weekEndDate"
      :week-number="weekNumber"
    />
    -->
  </div>
</template>

<script>
import moment from 'moment'
import WeeklyWbsGroups from './weekly-wbs-groups.vue'

export default {
  name: 'weekly-view-wbs',

  components: {
    WeeklyWbsGroups,
  },

  props: {
    projectId: {
      type: Number,
      default: null,
    },
    weekStartDate: {
      type: String,
      default: null,
    },
    weekEndDate: {
      type: String,
      default: null,
    },
    weekNumber: {
      type: Number,
      default: null,
    },
    filterSubactivitiesByWeek: {
      type: Boolean,
      default: true,
    },
    rescheduleMode: {
      type: Boolean,
      default: false,
    },
    editedSubactivities: {
      type: Array,
      default: () => [],
    },
    activityFilters: {
      type: Object,
      default: () => ({}),
    },
    selectedDisciplineId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      hiddenColumnGroups: [],
      groupFilters: [
        { key: 'info', columnGroup: 'tracking', labelKey: 'information', color: '#3b82f6', count: 13 },
        { key: 'planned_advance', columnGroup: 'planned_advance', labelKey: 'planned_advance', color: '#1e3a5f', count: 6 },
        { key: 'scheduled_advance', columnGroup: 'scheduled_advance', labelKey: 'scheduled_advance', color: '#166534', count: 6 },
        { key: 'real', columnGroup: 'real', labelKey: 'real_progress', color: '#7c3aed', count: 5 },
      ],
    }
  },

  computed: {
    summaryCounts() {
      return this.$t('activities_subactivities_count', {
        activities: 0,
        subactivities: 0,
      })
    },

    weekSummaryLabel() {
      if (!this.weekStartDate || !this.weekEndDate || this.weekNumber == null) {
        return ''
      }

      const start = moment(this.weekStartDate, 'YYYY-MM-DD', true)
      const end = moment(this.weekEndDate, 'YYYY-MM-DD', true)
      if (!start.isValid() || !end.isValid()) {
        return ''
      }

      const weekNum = String(this.weekNumber).padStart(2, '0')
      const rangeStart = start.format('DD/MM/YYYY')
      const rangeEnd = end.format('DD/MM/YYYY')
      const range = rangeStart === rangeEnd
        ? rangeStart
        : `${rangeStart} – ${rangeEnd}`

      return `Semana S${weekNum} · ${range}`
    },
  },

  methods: {
    isGroupHidden(groupKey) {
      return this.hiddenColumnGroups.includes(groupKey)
    },

    toggleColumnGroup(groupKey) {
      if (this.isGroupHidden(groupKey)) {
        this.hiddenColumnGroups = this.hiddenColumnGroups.filter((key) => key !== groupKey)
        return
      }
      this.hiddenColumnGroups = [...this.hiddenColumnGroups, groupKey]
    },
  },
}
</script>

<style scoped>
.activities-weekly-table__group-chip--hidden {
  opacity: 0.45;
}
</style>
